/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import HelpButton from 'app/components/common/HelpButton.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import * as _ from 'underscore';

class CreateFeedOutputPanel extends React.Component {
    constructor(props) {
        super(props);

        let constants = window.DlvrConstants;

        this.state = {
            feed: {
                psID: constants.POST_SVC_FEED,
                rID: 0,
                creds: {
                    numItems: 10,
                    guid: ''
                },
                name: '',
                staticTitle: '',
                activeFlag: 1
            }
        };

        this.onCancel = this.onCancel.bind(this);
        this.createFeedOutput = this.createFeedOutput.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let constants = window.DlvrConstants,
            feed = state.feed;


        if (props.router.params) {
            if (props.router.params.routeId !== undefined) {
                feed.rID = parseInt(props.router.params.routeId);
                return {
                    feed
                };
            }
        } else if (props.routeId) {
            feed.rID = parseInt(props.routeId);
            return {
                feed
            };
        }

        // create was triggered by the + button on the list row
        if (props.activeRoute) {
            feed.rID = parseInt(props.activeRoute.id);
            return {
                feed
            };
        }

        return null;
    }

    onCancel(e) {

        e.preventDefault();
        this.props.closeAllModals();

        if (!this.props.router.location.pathname.match("/config/social") &&
            !this.props.router.location.pathname.match("/content/post") &&
            _.findWhere(this.props.socials.counts, {type: constants.POST_SVC_BLUESKY}) !== undefined) {
            this.props.switchView("chooseAcct", constants.POST_SVC_BLUESKY);
        } else {
            this.props.switchView("chooseType");
        }

    }

    createFeedOutput(e) {

        e.preventDefault();
        if (_.isFunction(this.props.setNewSocial)) {
            this.props.setNewSocial(this.state.feed);
        }
        this.props.createSocial(this.state.feed);

    }

    render() {
        let feedActive = (parseInt(this.state.feed.activeFlag)) ? true : false,
            itemOptions = [
                {value: 5, label: 5},
                {value: 10, label: 10},
                {value: 15, label: 15},
                {value: 20, label: 20},
            ],
            feedName = (this.state.feed && this.state.feed.name) ? this.state.feed.name : '',
            staticTitle = (this.state.feed && this.state.feed.staticTitle) ? this.state.feed.staticTitle : '';

        return (
            <form>
                <div className="editor-panel clearfix">
                    <fieldset>
                        <legend>Output Feed Name <span className="required">*</span></legend>
                        <UncontrolledTextInput
                            className="text-input medium"
                            defaultValue={feedName}
                            data-field="feed.name"
                            onChange={FormUtilityMixin.requestChange.bind(this)}/>
                    </fieldset>
                    <fieldset>
                        <legend>Max Items in Output Feed</legend>
                        <StyledSelect
                            options={itemOptions}
                            linkedField="feed.creds.numItems"
                            value={this.state.feed.creds.numItems}
                            onChange={FormUtilityMixin.requestChange.bind(this)}
                            selectClass="med"/>
                    </fieldset>
                    <fieldset>
                        <legend>Static Title for Items<HelpButton which="staticTitle"/></legend>
                        <UncontrolledTextInput
                            className="text-input medium"
                            defaultValue={staticTitle}
                            data-field="feed.params.staticTitle"
                            onChange={FormUtilityMixin.requestChange.bind(this)}/>
                    </fieldset>
                    <fieldset>
                        <legend>Output Feed Active</legend>
                        <Toggle
                            active={feedActive}
                            noLabel={true}
                            callback={FormUtilityMixin.requestChange.bind(this)}
                            linkedField="feed.activeFlag" />
                    </fieldset>
                    <fieldset className="form-buttons">
                        <a href="#" className="form-cancel" onClick={this.onCancel}>cancel</a>
                        <button className="form-button" onClick={this.createFeedOutput}>Save</button>
                    </fieldset>
                </div>
            </form>
        );
    }

};

CreateFeedOutputPanel.displayName = "CreateFeedOutputPanel";

CreateFeedOutputPanel.propTypes = {
    switchView: PropTypes.func,
    router: PropTypes.object
};

CreateFeedOutputPanel.defaultProps = {
    switchView: null,
    router: null
};

export default CreateFeedOutputPanel;
